import { formatTime } from "./formatTime";
import { getTimezoneAbbreviation } from "./getTimezoneAbbreviation";

/**
 * Formats a date into a string in the format "9:30 am (PST)"
 * If includeTimezone is false, returns just the time without timezone
 */
export function formatTimeWithTimezone(
  date: Date,
  timezone: string,
  includeTimezone = true
): string {
  const timeString = formatTime(date, timezone);

  if (!includeTimezone) {
    return timeString;
  }

  const timezoneAbbr = getTimezoneAbbreviation(timezone);
  return `${timeString} (${timezoneAbbr})`;
}
